<template>
  <div ref="modalBeforeContainer" id="before-modal-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ModalBeforeContainer",
  mounted() {
    // this will render the modal in the correct place
    document.getElementById('page-modals').prepend(this.$refs.modalBeforeContainer);
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";
</style>
